// 9031/9032: times read on the water use the 24-hour clock (e.g. 14:05), never AM/PM.

/** "14:05" */
export function time24(ts) {
  if (!ts) return '—';
  return new Date(ts).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
}

/** "29 Oct 2026, 14:05" */
export function dateTime24(ts) {
  if (!ts) return '—';
  return new Date(ts).toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}
